module.exports = __webpack_public_path__ + "static/media/suit_monogram.a3c61d44.jpg";